import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import dateFormat, { masks } from "dateformat";
class LeaseInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leaseData: this.props.leaseData,
    };
  }

  amendNumber(str) {
    return str.split("-").pop();
  }

  setPopupHeading() {
    if (
      this.state.leaseData.type == "" ||
      this.state.leaseData.type == "original"
    ) {
      return "Create Lease";
    } else if (this.state.leaseData.type == "amend") {
      return "Amend Lease";
    } else if (this.state.leaseData.type == "extend") {
      return "Extend Lease";
    } else if (this.state.leaseData.type == "renew") {
      return "Renew Lease";
    } else if (this.state.leaseData.type == "terminate") {
      return "Terminate Lease";
    } else {
      return "Create Lease";
    }
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="tableContainer leaseLandlord">
            <table className="table tableSimple tableSimpleWithNoFlex">
              {this.state.leaseData.type == "" && (
                <tbody>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Activity</th>
                    <td>Create Lease</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Number</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                

                  


                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Created By</th>
                    <td>{this.state.leaseData.created_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Creation Date & Time</th>
                    <td>{this.state.leaseData.created_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Submitted By</th>
                    <td>{this.state.leaseData.submitted_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Submitted Date & Time</th>
                    <td>{this.state.leaseData.submitted_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Approved By</th>
                    <td>{this.state.leaseData.approved_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Approval Date & Time</th>
                    <td>{this.state.leaseData.approved_at}</td>
                  </tr>
                </tbody>
              )}
              {this.state.leaseData.type == "original" && (
                <tbody>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Activity</th>
                    <td>Create Lease</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Number</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Number</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Created By</th>
                    <td>{this.state.leaseData.created_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Creation Date & Time</th>
                    <td>{this.state.leaseData.created_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Submitted By</th>
                    <td>{this.state.leaseData.submitted_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Submitted Date & Time</th>
                    <td>{this.state.leaseData.submitted_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Approved By</th>
                    <td>{this.state.leaseData.approved_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Approval Date & Time</th>
                    <td>{this.state.leaseData.approved_at}</td>
                  </tr>
                </tbody>
              )}
              {this.state.leaseData.type == "amend" && (
                <tbody>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Activity</th>
                    <td>Amend Lease</td>
                  </tr>
                 
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Amendment No</th>
                    <td>{this.amendNumber(this.state.leaseData.lease_code)}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Original Lease Number</th>
                    <td>{this.state.leaseData.original_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Amended Lease No</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Amended By</th>
                    <td>{this.state.leaseData.created_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Amend Date & Time</th>
                    <td>{this.state.leaseData.created_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Amended Screens</th>
                    <td>{this.state.leaseData.ammen_screens}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Amend Submitted By</th>
                    <td>{this.state.leaseData.submitted_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Amend Submit Date & Time</th>
                    <td>{this.state.leaseData.submitted_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Amend Approved By</th>
                    <td>{this.state.leaseData.approved_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Amend Approved Date & Time</th>
                    <td>{this.state.leaseData.approved_at}</td>
                  </tr>
                </tbody>
              )}
              {this.state.leaseData.type == "extend" && (
                <tbody>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Activity</th>
                    <td>Extend Lease</td>
                  </tr>
                 
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Extension No</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Original Lease Number</th>
                    <td>{this.state.leaseData.original_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Extended Lease No</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Extended By</th>
                    <td>{this.state.leaseData.created_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Extension Date & Time</th>
                    <td>{this.state.leaseData.created_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Extend Submitted By</th>
                    <td>{this.state.leaseData.submitted_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Extend Submit Date & Time</th>
                    <td>{this.state.leaseData.submitted_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Extend Approved By</th>
                    <td>{this.state.leaseData.approved_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Extend Approved Date & Time</th>
                    <td>{this.state.leaseData.approved_at}</td>
                  </tr>
                </tbody>
              )}
              {this.state.leaseData.type == "renew" && (
                <tbody>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Activity</th>
                    <td>Renew Lease</td>
                  </tr>
                  
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Renewal No</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Original Lease Number</th>
                    <td>{this.state.original_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Renewed Lease No</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Renewed By</th>
                    <td>{this.state.leaseData.created_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Renew Date & Time</th>
                    <td>{this.state.leaseData.created_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Renew Submitted By</th>
                    <td>{this.state.leaseData.submitted_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Renew Submit Date & Time</th>
                    <td>{this.state.leaseData.submitted_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Renew Approved By</th>
                    <td>{this.state.leaseData.approved_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Renew Approved Date & Time</th>
                    <td>{this.state.leaseData.approved_at}</td>
                  </tr>
                </tbody>
              )}
              {this.state.leaseData.type == "terminate" && (
                <tbody>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Activity</th>
                    <td>Terminate Lease</td>
                  </tr>
                  
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Original Lease Number</th>
                    <td>{this.state.original_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Last Lease Number</th>
                    <td>{this.state.leaseData.lease_code}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Terminated By</th>
                    <td>{this.state.leaseData.terminated_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgGray">
                    <th scope="col">Lease Terminate Date & Time</th>
                    <td>{this.state.leaseData.terminated_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Terminate Submitted By</th>
                    <td>{this.state.leaseData.submitted_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgDarkBlue">
                    <th scope="col">Lease Terminate Submit Date & Time</th>
                    <td>{this.state.leaseData.submitted_at}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Terminate Approved By</th>
                    <td>{this.state.leaseData.approved_by}</td>
                  </tr>
                  <tr className="leaseDetailsBgBlue">
                    <th scope="col">Lease Terminate Approved Date & Time</th>
                    <td>{this.state.leaseData.approved_at}</td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(LeaseInformation);
